import { FC, memo } from 'react'

import { AccordionNoRadix, Text } from '@cash-me/react-components'

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'

import { list } from './data'
import { AccordionProps } from './questions.model'
import * as S from './styles'

export const Questions: FC = memo(() => {
  const BreadcrumbLinks = [{ label: 'Aviso de Privacidade' }]

  return (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
        <Col col={{ desktop: 8 }} start={{ desktop: 3 }}>
          <Breadcrumb items={BreadcrumbLinks} />
          <S.Title>Aviso de Privacidade CashMe</S.Title>
          <S.AccordionWrapper>
            {list.map(({ id, title, content }: AccordionProps) => (
              <AccordionNoRadix
                key={id}
                id={id}
                title={
                  <Text as="h3" size="heading4" weight="medium" color="var(--colors-neutral-text-default)">
                    {title}
                  </Text>
                }
              >
                {content}
              </AccordionNoRadix>
            ))}
          </S.AccordionWrapper>
        </Col>
      </Grid>
    </S.Section>
  )
})

Questions.displayName = 'Questions'
